<template>
  <div class="start">
    <div class="inputBox">
      <div class="war">请输入至少12位兑换码开始兑换</div>
      <input ref="input" placeholder="请输入兑换码" type="text" />
      <!-- <input style="marginTop:16px" ref="batch" placeholder="请输入批次号"  type="text"> -->
      <div class="btn">
        <img
          @click="goPage"
          src="https://frontassets.oss-cn-shanghai.aliyuncs.com/giftExchange/kaishiduihuan.png"
          alt=""
        />
      </div>
    </div>
    <div class="tel mar20">电话咨询热线：{{phone}}</div>
    <div class="tel">服务时间：工作日 上午{{workTime}}</div>
  </div>
</template>

<script>
import { query, queryPost } from "@/core/service/api";
import { Toast } from "vant";
import { rsaEndCode } from "@/core/utils/utils";

export default {
  name: "start",
  data() {
    return {
      phone: "021-23106668",
      workTime: "10：00-12：00，13：30-17：30"
    };
  },
  created() {
    this.getKey();
  },
  mounted() {
    const firstBrandId = localStorage.getItem("firstBrandId");
      const firstBrandPhoneMap = {
        "73a35a75431d571292e9022092723ec8" : "15707023624",
        "865bb6bf598be724455f914ac4fbba6c" : "17521160348/13917555784",
        "a38851d291d12afcb09cc5a1b3569a16" : "021-23106668"
      };
      
    this.phone =  firstBrandId != null && firstBrandPhoneMap[firstBrandId] != null ? firstBrandPhoneMap[firstBrandId] : "021-23106668";
    const firstBrandWorkTimeMap = {
        "73a35a75431d571292e9022092723ec8" : "10：00-12：00，13：00-18：00",
        "865bb6bf598be724455f914ac4fbba6c" : "10：00-12：00，13：30-17：30",
        "a38851d291d12afcb09cc5a1b3569a16" : "10：00-12：00，13：30-17：30"
      };

    this.workTime =  firstBrandId != null && firstBrandWorkTimeMap[firstBrandId] != null ? firstBrandWorkTimeMap[firstBrandId] : "10：00-12：00，13：30-17：30";
    this.$refs.input.value = localStorage.getItem("redeemCode");
  },
  methods: {
    async getKey() {
      let res = await query("/isg-projectapplication/gift/exchange/publicKey");
      localStorage.setItem("pubKey", res.result);
    },
    async goPage() {
      // this.$store.dispatch({type:'start/saveCode',amount:{exChangeCode:this.$refs.input.value}});
      // this.$store.dispatch({type:'start/saveCode',amount:{batchCode:this.$refs.batch.value}});
      if (!this.$refs.input.value || this.$refs.input.value == "") {
        Toast.fail("请输入兑换码");
        return;
      }

      localStorage.setItem("exChangeCode", this.$refs.input.value.substring(0, 8));
      localStorage.setItem(
        "batchCode",
        this.$refs.input.value.substring(8, this.$refs.input.value.length)
      );
      console.log(
        localStorage.getItem("exChangeCode"),
        localStorage.getItem("batchCode")
      );

      const timestamp = new Date().getTime();
      const data = {
        firstBrandId: localStorage.getItem("firstBrandId"),
        projectIntegralId: localStorage.getItem("projectIntegralId"),
        redemptionCode: localStorage.getItem("exChangeCode"),
        batchId: localStorage.getItem("batchCode"),
        timestamp,
      };
      const value = {
        key: rsaEndCode(localStorage.getItem("pubKey"), JSON.stringify(data)),
        timestamp,
      };
      let res = await queryPost(value, "/isg-projectapplication/gift/exchange/exchange");

      const { code } = res;
      if (code === "0") {
        const { bosp, isSkip } = res.result;
        localStorage.setItem("isSkip", isSkip);
        if (isSkip === 0 || bosp.length > 1) {
          this.$router.push("/giftlist");
        } else {
          // console.log('@@',bosp)
          this.$router.push({
            path: "/input",
            query: { ...bosp[0] },
          });
        }
      }
    },
  },
};
</script>
<style lang="scss">
.start {
  background: url(https://frontassets.oss-cn-shanghai.aliyuncs.com/giftExchange/dhlp.png)
    no-repeat;
  background-color: #bfefdb;
  background-position: 0 64px;
  background-size: 100% auto;
  height: 100vh;
  min-height: 700px;
  padding-top: 306px;
  box-sizing: border-box;
  .war {
    color: #ee9945;
    font-size: 11px;
    text-align: center;
    margin-bottom: 26px;
  }
  .tel {
    color: #41ba9e;
    font-size: 11px;
    text-align: center;
    height: 15px;
    line-height: 15px;
    margin-top: 4px;
  }
  .mar20 {
    margin-top: 18px;
  }
  .inputBox {
    width: 351px;
    height: 319px;
    background: url(https://frontassets.oss-cn-shanghai.aliyuncs.com/giftExchange/dhmbg2.png)
      no-repeat;
    background-size: 100% 100%;
    padding-top: 61px;
    box-sizing: border-box;
    margin: 0 auto;
    input {
      width: 222px;
      height: 44px;
      display: block;
      background: #fdf0dc;
      box-shadow: 0px 0px 3px 1px rgba(244, 207, 96, 0.15);
      border-radius: 22px;
      margin: 0 auto;
      border: 0;
      padding: 10px;
      box-sizing: border-box;
      text-align: center;
      font-size: 16px;
    }
    input::-webkit-input-placeholder {
      color: #ee9945;
      font-size: 16px;
    }

    .btn {
      width: 118px;
      height: 122px;
      margin: 25px auto 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
